import { useQuery } from '@tanstack/react-query';
import decodeJson from '@seccon/shared/utils/decodeJson';
import ApiError from '@seccon/shared/utils/ApiError';

const fetchPersonnelToVerify = (sessionId) => fetch(`/personnelComparisonTool/${ sessionId }/personnelToVerify`).then(decodeJson)
  .catch(({ body }) => {
    throw new ApiError(
      body ? `Error: ${ body }` : 'Could not load Personnel to verify data'
    );
  });
function processPersonnel (response) {
  return response?.personnelToVerify?.map((person) => ({
    id: person.mappedId,
    label: person.name
  }));
}
const usePersonnelToVerify = (sessionId) => useQuery({
  queryKey: ['personnelToVerify', sessionId],
  queryFn: () => fetchPersonnelToVerify(sessionId),
  enabled: !!sessionId,
  staleTime: 0,
  select: processPersonnel,
  refetchOnWindowFocus: false
})

export default usePersonnelToVerify;
